import {
  CustomProvider,
  Divider,
  Header,
  Heading,
  HeadingGroup,
  Container,
  Sidebar,
  Sidenav,
  Text,
  Nav,
  Content,
  CardGroup,
  Card,
  Footer
} from 'rsuite';

import React from 'react';

import News from './components/News.js';
import Reader from './components/Reader.js'

import 'rsuite/dist/rsuite.css';

function App() {
  const [page, setPage] = React.useState('news');
  const [book, setBook] = React.useState('');
  const [pageNum, setPageNum] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  return (
    <CustomProvider theme='high-contrast'>
    <Container height='100vh'>
      <Header onClick={()=>setPage('news')}>
          <Text size='6rem' display='inline' paddingLeft={'20px'}>The Squeaky Press </Text>
          <Text size='xl' display='inline'>gets the cheese...</Text>
      </Header>
      <Container>
        <Sidebar style={{ display: 'flex', flexDirection: 'column', paddingLeft: '20px'}}>
          <Sidenav>
          <Sidenav.Header>
            <Text align='center' size='xl'>Content</Text>
          </Sidenav.Header>
            <Sidenav.Body>
              <Nav>
                <Nav.Item onClick={()=>setPage('news')}>News</Nav.Item>
                <Nav.Menu title='Books' eventKey='1'>
                  <Nav.Item onClick={()=>[setPage('book'), setBook('mac'), setPageNum(1), setTotalPages(24)]}>Mac the Mouse</Nav.Item>
                  <Nav.Item onClick={()=>[setPage('book'), setBook('orangutan'), setPageNum(1), setTotalPages(12)]}>Orangutan Painters</Nav.Item>
                  <Nav.Item onClick={()=>[setPage('book'), setBook('fruit'), setPageNum(1), setTotalPages(6)]}>Green Orange</Nav.Item>
                </Nav.Menu>
                <Nav.Menu title='Movies' eventKey='2'>
                  <Nav.Item onClick={()=>setPage('sprint')}>JumpRopeSprint</Nav.Item>
                </Nav.Menu>
              </Nav>
            </Sidenav.Body>
          </Sidenav>
        </Sidebar>
        <Content paddingLeft={'40px'} paddingRight={'40px'}>
          {page === 'news' && <News />}
          {page === 'book' && <Reader book={book} pageNum={pageNum} setPageNum={setPageNum} totalPages={totalPages} />}
        </Content>
        <Sidebar style={{ display: 'flex', flexDirection: 'column'}}></Sidebar>
      </Container>
      <Divider></Divider>
      <Footer>
        <Text align={'center'}>Contact us.</Text>
      </Footer>
    </Container>
    </CustomProvider>
  );
}

export default App;
